
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"

interface DiscountCodeInputProps {
  discountCode: string
  onDiscountCodeChange: (code: string) => void
  onApply: () => void
}

export function DiscountCodeInput({ 
  discountCode, 
  onDiscountCodeChange, 
  onApply 
}: DiscountCodeInputProps) {
  return (
    <div className="flex gap-2">
      <Input
        placeholder="Enter discount code"
        value={discountCode}
        onChange={(e) => onDiscountCodeChange(e.target.value)}
      />
      <Button onClick={onApply}>Apply</Button>
    </div>
  )
}
